import { z } from "zod";

export interface AccountsCostQueryParams {
  start_date?: string;
  end_date?: string;
  aggregation_level?: "day" | "month";
  accounts?: string[];
  page?: number;
  page_size?: number;
}

// Account List Response
export const accountsListSchema = z.array(z.string());
export type AccountsList = z.infer<typeof accountsListSchema>;

// Total Cost Response
export const totalCostSchema = z.object({
  cost: z.number(),
});
export type TotalCost = z.infer<typeof totalCostSchema>;

// Chart Data Response
export const chartDataSchema = z.object({
  date: z.string(),
  compute: z.number().optional(),
  storage: z.number().optional(),
  serverless: z.number().optional(),
  cloud: z.number().optional(),
  ai_services: z.number().optional(),
  others: z.number().optional(),
});
export const chartDataListSchema = z.array(chartDataSchema);
export type ChartData = z.infer<typeof chartDataSchema>;
export type ChartDataList = z.infer<typeof chartDataListSchema>;

// Table Data Response
export const tableDataSchema = z.object({
  account_name: z.string(),
  compute: z.number(),
  storage: z.number(),
  serverless: z.number(),
  cloud: z.number(),
  ai_services: z.number(),
  total: z.number(),
  others: z.number(),
});
export const tableDataListSchema = z.array(tableDataSchema);
export type TableData = z.infer<typeof tableDataSchema>;
export type TableDataList = z.infer<typeof tableDataListSchema>;

// Query Keys
export const GET_ACCOUNTS_LIST = "GET_ACCOUNTS_LIST";
export const GET_ACCOUNTS_TOTAL_COST = "GET_ACCOUNTS_TOTAL_COST";
export const GET_ACCOUNTS_CHART_DATA = "GET_ACCOUNTS_CHART_DATA";
export const GET_ACCOUNTS_TABLE_DATA = "GET_ACCOUNTS_TABLE_DATA";
